import { useTranslation } from "react-i18next";
import DgiElement from "./DgiElement";
import {Consts} from "../pages/consts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import React from "react";

const DgiInfo = ({ showInfo, setShowInfo, drug }) => {
  const { t } = useTranslation();

  return (
    <div className="w3-modal" style={{ display: showInfo ? Consts.BLOCK : Consts.NONE }}>
      <div className="w3-modal-content w3-animate-zoom ddi-dgi-panel dialog-medium">
        <header className="feedback-modal-header">
          <h2>{t("drug_gene_interactions")}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="modal-close"
            onClick={() => setShowInfo(false)}
          />
        </header>
        <div className="w3-container w3-left-align w3-border w3-round-large w3-margin-top">
          {drug?.dgis && (
            <>
              <div className="w3-row">
                <label className="bold-label">
                  {drug?.activeSubstance} {t("containing_in_your_medicine")}{" "}
                  {drug?.productName === Consts.NOT_SPECIFIED
                    ? t(Consts.NOT_SPECIFIED)
                    : drug?.productName}{" "}
                  {t("has_drug_gene_interactions_with")}
                </label>
              </div>
              {drug?.dgis?.map((dgi, n) => {
                return <DgiElement dgi={dgi} number={n} key={`dgi${n}`} substance={drug?.activeSubstance}/>;
              })}
              <div className="w3-row">
                <a
                  href="https://www.knmp.nl/dossiers/farmacogenetica/pharmacogenetics"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w3-text-green"
                >
                  {t("dgi_source")}
                </a>
              </div>
              {drug?.dgis?.length > 0 && (
                <div className="w3-row">
                  <label className="notice-text">
                    ⚠️ {t("always_discuss_with_hcp_notice")}
                  </label>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DgiInfo;
